<template>
  <div
    v-if="flashcard"
    ref="flashcard-view-container"
    class="flashcard-view-container"
  >
    <flashcard
      :answered="answered"
      :answer-ids="answerIds"
      :correct="correct"
      :flashcard="flashcard"
      :terminolgoy="isTerminology"
      :raw-answer-data="rawAnswerData"
      @set-answer-ids="setAnswerIds"
      @set-raw-answer-data="setRawAnswerData"
    />
    <flashcard-footer
      :allow-skipping="true"
      :answered="answered"
      :answer-ids="answerIds"
      :correct="correct"
      :flashcard="flashcard"
      :raw-answer-data="rawAnswerData"
      :show-bookmark="false"
      :show-flashcard-statuses="false"
      @answer="onAnswered"
      @next-flashcard="returnToLastRoute"
      @skip="skipFlashcard"
    />
  </div>
  <loading v-else />
</template>

<script>
import Loading from '@/components/singletons/loading';
import Flashcard from '@/components/flashcards/flashcard';
import FlashcardFooter from '@/components/flashcards/footer';

import FlashcardViewMixin from '@/mixins/flashcardViews';

import { rateLimitingEnabled } from '@/utils';

export default {
  components: { Flashcard, FlashcardFooter, Loading },
  mixins: [FlashcardViewMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.setLastRoute(from);
    });
  },
  data() {
    return {
      flashcardId: null,
      lastRoute: null,
    };
  },
  computed: {
    flashcard() {
      if (this.flashcardId) {
        return this.$store.getters['flashcards/flashcards'][this.flashcardId];
      }
    },
    assetAssociationId() {
      return this.$route.params.assetAssociationId;
    },
  },
  mounted() {
    this.fetchAsset();
  },
  methods: {
    fetchAsset() {
      this.$store.dispatch('assetAssociations/assets',
      {
        assetAssociationIds: [this.assetAssociationId],
        rateLimtied: rateLimitingEnabled({ apptimize: this.$apptimize, store: this.$store, analytics: this.$analytics }),
      }).then(({ flashcards }) => this.flashcardId = flashcards[0].id);
    },
    onAnswered() {
      const correct = this.evaluateAnswer(this.currentFlashcard, this.answerIds, this.rawAnswerData);
      this.correct = correct;
      this.answered = true;
    },
    returnToLastRoute() {
      if (this.lastRoute) {
        this.$router.push({ ...this.lastRoute });
      } else {
        this.$router.go(-1);
      }
    },
    setLastRoute(route) {
      const { name, params } = route;
      const { query } = this.$route;

      this.lastRoute = { name, params, query };
    },
  },
};
</script>

<style lang="scss" scoped>
  .flashcard-view-container {
    @include flashcard-view;
  }
</style>
